import { getEnvVar } from '@/utils'

export type Env = 'production' | 'preproduction' | 'staging' | 'dev'

export const environment = {
  helpUrl: getEnvVar<string>('VITE_HELP_URL') || '',
  datadogApplicationId: getEnvVar<string>('VITE_DD_CATALOG_APP_ID') || '',
  datadogClientToken: getEnvVar<string>('VITE_DD_CATALOG_CLIENT_TOKEN') || '',
  datadogEnv: getEnvVar<string>('VITE_DD_ENV') || 'development',
  datadogServiceName: getEnvVar<string>('VITE_DD_CATALOG_SERVICE_NAME') || '',
  datadogSessionReplaySampleRate: getEnvVar<number>('VITE_DD_CATALOG_SESSION_REPLAY_SAMPLE_RATE') || 0,
  datadogVersion: getEnvVar<string>('VITE_DD_CATALOG_VERSION') || '',
  datadogSite: getEnvVar<string>('VITE_DD_SITE') || 'datadoghq.eu',
  beamerId: getEnvVar<string>('VITE_BEAMER_ID') || '',
  appVersion: getEnvVar<string>('VITE_APP_VERSION') || '',
  amplitudeApiKey: getEnvVar<string>('VITE_AMPLITUDE_API_KEY') || '',
  amplitudeApiKeyDev: getEnvVar<string>('VITE_AMPLITUDE_API_KEY_DEV') || '',
  env: getEnvVar<Env>('VITE_NODE_ENV') || '',
  test: getEnvVar<string>('VITE_NODE_ENV') === 'test',
}
